import { pick } from 'lodash';
import { HELPER_TEXT_ATTRIBUTES, LABEL_ATTRIBUTES } from '~/assets/javascript/constants';

export default class ChartInfoComponentFromOptionBuilder {
  static build(infoComponentOption) {
    return new ChartInfoComponentFromOptionBuilder(infoComponentOption).build();
  }

  constructor(infoComponentOption) {
    this.chartInfoComponentOption = infoComponentOption;
  }

  build() {
    return {
      ...pick(
        this.chartInfoComponentOption,
        [
          'columns',
          'content',
          'id',
          'rows',
          'type',
          ...HELPER_TEXT_ATTRIBUTES,
          ...LABEL_ATTRIBUTES,
        ],
      ),
    };
  }
}
